import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dee2dadc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "headerWrap"
};
const _hoisted_2 = {
  class: "leftwrap"
};
const _hoisted_3 = {
  class: "leftcon1"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-edit"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "leftcon2"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-narrow"
}), /*#__PURE__*/_createElementVNode("span", null, "100%"), /*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-enlarge"
})], -1));
const _hoisted_8 = {
  class: "rightwrap"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "rightcon1"
}, [/*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-revoke"
}), /*#__PURE__*/_createElementVNode("span", null, "撤销")]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon icon-recovery"
}), /*#__PURE__*/_createElementVNode("span", null, "恢复")])], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_11 = {
  class: "rightcon2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString($data.title), 1), _hoisted_5]), _hoisted_6, _hoisted_7]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    plain: ""
  }, {
    default: _withCtx(() => [_createTextVNode("预览")]),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    plain: ""
  }, {
    default: _withCtx(() => [_createTextVNode("保存")]),
    _: 1
  })])])]);
}